import React from "react";
import LoginForm from "../../components/LoginForm/LoginForm.component";

export default function LoginPage() {
  return <LoginForm />;
}
